module.exports = __webpack_public_path__ + "img/p5.db9c9361.png";